import * as AlertDialog from "@radix-ui/react-alert-dialog";
import type { ProductDetails } from "@raumagarn/formatters";
import { useQuery } from "@tanstack/react-query";
import { clsx } from "@trydig/ui";
import { DownloadIcon } from "~/components/icons/16/DownloadIcon";
import { ShowroomBuyerSelect } from "~/components/ui/ShowroomBuyerSelect";
import pdpStyles from "~/features/products/ProductDetails/PdpActions/PdpActions.module.css";
import { fetchWholesaleDisplayPricing } from "~/features/products/ProductDetails/PdpActions/variants/Recipe/actions";
import { useShowroom, useShowroomBuyer } from "~/lib/showroom/hooks/useShowroom";
import styles from "./DownloadRecipe.module.css";

export const DownloadRecipeShowroom = ({ product }: { product: ProductDetails }) => {
	const { data, token } = useShowroom();
	const { buyerId, setBuyerId } = useShowroomBuyer();
	const { data: price } = useQuery({
		queryKey: ["wholesale-pricing", product.uri!],
		queryFn: () => fetchWholesaleDisplayPricing({ uri: product.uri! }),
	});

	const hasBuyerId = typeof buyerId === "number";

	const buyer = data?.buyers?.find((b) => Number(b.id) === buyerId);

	if (!data) return null;

	return (
		<AlertDialog.Root>
			<AlertDialog.Trigger asChild>
				<button type="button" className={clsx("transparent small")} onClick={() => {}}>
					<DownloadIcon />
					<span className={pdpStyles.label}>Last ned</span>
				</button>
			</AlertDialog.Trigger>
			<AlertDialog.Portal>
				<AlertDialog.Overlay className="dialog-overlay" />
				<AlertDialog.Content
					className={clsx("dialog-content", pdpStyles["dialog-content"], styles.dialogContent)}
				>
					<AlertDialog.Title className={styles.dialogTitle}>Last ned oppskriften</AlertDialog.Title>
					<AlertDialog.Description>
						{hasBuyerId && (
							<>
								Du blir fakturert for denne oppskriften ihht. gjeldende avtaler.
								<br />
							</>
						)}
						{!hasBuyerId && (
							<>
								<br />
								<span className={styles.errorMessage}>
									Du må velge kjøper for å laste ned oppskriften.
								</span>
							</>
						)}
						<span className={styles.buyerSelect}>
							<label htmlFor="">Velg kjøper</label>
							{!!data.buyers && (
								<ShowroomBuyerSelect
									buyers={data.buyers}
									onBuyerChange={setBuyerId}
									value={buyerId}
								/>
							)}
						</span>
					</AlertDialog.Description>
					<div className={pdpStyles["modal-actions"]}>
						<AlertDialog.Cancel className={clsx("transparent small")}>Avbryt</AlertDialog.Cancel>
						<AlertDialog.Action
							asChild
							disabled={!hasBuyerId}
							className={clsx(!hasBuyerId && styles.disabled, "small")}
						>
							<a
								type="button"
								href={`/api/assets/showroom/pdf/${product.centraProduct}?buyerId=${buyerId}&token=${token}`}
								target="_blank"
								onClick={(event) => {
									if (!hasBuyerId) event.preventDefault();
								}}
								rel="noopener"
							>
								<DownloadIcon />
								<span className={pdpStyles.label}>Last ned</span>
							</a>
						</AlertDialog.Action>
					</div>
				</AlertDialog.Content>
			</AlertDialog.Portal>
		</AlertDialog.Root>
	);
};

export const PreviewRecipe = ({ product }: { product: ProductDetails }) => {
	const { data, token } = useShowroom();
	const { buyerId, setBuyerId } = useShowroomBuyer();
	return (
		<a
			href={`/api/assets/showroom/pdf/${product.centraProduct}/preview?buyerId=${buyerId}&token=${token}`}
			type="button"
			target="_blank"
			className={clsx("transparent small")}
			onClick={() => {}}
			rel="noopener"
		>
			<DownloadIcon />
			<span>Forhåndsvis</span>
		</a>
	);
};
